import { Avatar, Link, Stack, Typography } from '@mui/material'
import { Divider } from 'utoniq-ui'

import { CommentBoxFragment } from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type TradeMessageBoxProps = {
  message: CommentBoxFragment
}

export const TradeMessageBox: Cell<TradeMessageBoxProps> = ({ message }) => {
  const { routerPages, generatePath } = useRouter()

  return (
    <CellFrame>
      <Stack sx={{ py: 5 }}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          sx={{ px: 5, width: 'fit-content' }}
          component={Link}
          href={generatePath(routerPages.UserProfile, {
            userId: message.commenter.id ?? '',
          })}
        >
          <Avatar
            src={message.commenter.avatar?.smallUri ?? ''}
            sx={{ width: 28, height: 28 }}
          />
          <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 5 }}>
            {message.commenter.displayName}
          </Typography>
        </Stack>
        <Typography
          sx={{ px: 5, py: 2, wordBreak: 'break-all' }}
          variant="body2"
          color="text.primary"
        >
          {message.content}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ textAlign: 'right', px: 5 }}
        >
          {message.formattedCreatedAt}
        </Typography>
      </Stack>
      <Divider sx={{ mx: 5 }} />
    </CellFrame>
  )
}
